import { Injectable } from "@angular/core";

import { BehaviorSubject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";

import { HabilitationType } from "../../models/habilitation-type.model";

export type WindowParams = {
  titleMessage: string;
  bodyMessage: string;
  confirmTextMessage: string;
  declineTextMessage: string;
};

@Injectable({
  providedIn: "root",
})
export class ConfirmWindowService {

  params = new BehaviorSubject<WindowParams>(undefined);

  constructor(private readonly translate: TranslateService) {}

  configMessage(params: WindowParams){
    this.params.next(params);
  }

  closeHabilitation(habilitationType: HabilitationType) {
    const params: WindowParams = {
      titleMessage: this.translate.instant("confirm-window.supprimer.title"),
      bodyMessage: [HabilitationType.DELEGUE_PM, HabilitationType.CL_PM].includes(habilitationType) ? this.translate.instant("confirm-window.supprimer.descriptionTiers")
        : this.translate.instant("confirm-window.supprimer.description"),
      confirmTextMessage: this.translate.instant("confirm-window.supprimer.confirm"),
      declineTextMessage: this.translate.instant("confirm-window.supprimer.decline"),
    };
    this.configMessage(params);
  }

  abandonnerHabilitation() {
    const params: WindowParams = {
      titleMessage: this.translate.instant('confirm-window.abandonner.title'),
      bodyMessage: this.translate.instant('confirm-window.abandonner.description'),
      confirmTextMessage: this.translate.instant('confirm-window.abandonner.confirm'),
      declineTextMessage: this.translate.instant('confirm-window.abandonner.decline')
    }
    this.configMessage(params);
  }

  deconnexion() {
    const params: WindowParams = {
      titleMessage: this.translate.instant("confirm-window.deconnexion.title"),
      bodyMessage: this.translate.instant("confirm-window.deconnexion.description"),
      confirmTextMessage: this.translate.instant("confirm-window.deconnexion.confirm"),
      declineTextMessage: this.translate.instant("confirm-window.deconnexion.decline"),
    };
    this.configMessage(params);
  }

}
